"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var UIUtils_1 = require("../../../../../../../../shared/modules/UIUtils");
var react_ace_1 = require("react-ace");
var CardRowButtonTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowButtonTextEditor");
var BrandSmsTemplateTestJSONEditor = /** @class */ (function (_super) {
    __extends(BrandSmsTemplateTestJSONEditor, _super);
    function BrandSmsTemplateTestJSONEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandSmsTemplateTestJSONEditor.prototype.componentWillMount = function () {
        this.setState({
            jsonTestRaw: UIUtils_1.UIUtils.Base64DecodeU(this.props.testJSONBase64),
            SmsToSend: this.props.record.for_test_sms,
            is_window_maximized: false
        });
        this.props.state.setExtBreadCrumbPath([
            "Шаблоны Sms",
            "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0442\u0435\u0441\u0442\u043E\u0432\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445: [" + this.props.record.title + "]"
        ]);
    };
    BrandSmsTemplateTestJSONEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.SetGwsSmsTestJSONContent(this.props.record.key, UIUtils_1.UIUtils.Base64EncodeU(this.state.jsonTestRaw), this.state.SmsToSend, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Конфигурация успешно изменена!");
            });
        }
        else {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Контент не может быть пуcтым!");
        }
    };
    BrandSmsTemplateTestJSONEditor.prototype.OnLoadDataClick = function () {
        var _this = this;
        this.props.data.GetRawTestJSONData(this.props.record.key, function (dataBase64) {
            _this.setState({
                jsonTestRaw: UIUtils_1.UIUtils.Base64DecodeU(dataBase64),
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Конфигурация успешно загружена!");
            });
        });
    };
    BrandSmsTemplateTestJSONEditor.prototype.isDataValid = function () {
        if (!this.state.jsonTestRaw) {
            return false;
        }
        if (this.state.jsonTestRaw.length === 0) {
            return false;
        }
        return true;
    };
    BrandSmsTemplateTestJSONEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandSmsTemplateTestJSONEditor.prototype.OnMaxButtonClick = function (isMax) {
        this.setState({ is_window_maximized: isMax });
    };
    BrandSmsTemplateTestJSONEditor.prototype.getFormTitle = function () {
        return "Изменить тестовые данные";
    };
    BrandSmsTemplateTestJSONEditor.prototype.onChangeJSON = function (newValue) {
        this.setState({ jsonTestRaw: newValue });
    };
    BrandSmsTemplateTestJSONEditor.prototype.onTryToSendSmsClick = function () {
        if (this.state.SmsToSend) {
            if (this.state.SmsToSend.length >= 5) {
                this.props.data.CheckGwsSmsTemplate(this.props.record.key, function () {
                    notificationHelper_1.default.ShowTextTopRightInfoNotify("Запрос на отправку Sms выполнен!");
                });
            }
            else {
                notificationHelper_1.default.ShowTextTopRightErrorNotify("Поле Sms некорректно");
            }
        }
        else {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Поле Sms не заполнено");
        }
    };
    BrandSmsTemplateTestJSONEditor.prototype.getEditorHeight = function () {
        if (this.state.is_window_maximized) {
            return "calc( 100vh - 330px )";
        }
        else {
            return "410px";
        }
    };
    BrandSmsTemplateTestJSONEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), onMaxButtonClick: this.OnMaxButtonClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600, showMaxButton: true },
            React.createElement("div", { style: {
                    minHeight: "500px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start"
                } },
                React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Номер телефона:", placeholder: "Sms для тестовой отправки", buttonHint: "Отправить Sms" }, readonly: false, onButtonClick: this.onTryToSendSmsClick.bind(this), onValueChanged: function (newVal) {
                        _this.setState({
                            SmsToSend: newVal
                        });
                    }, value: this.state.SmsToSend, buttonIcon: "phone" }),
                React.createElement(react_ace_1.default, { mode: "json", theme: "sqlserver", onChange: this.onChangeJSON.bind(this), name: "UNIQUE_ID_OF_RECORD_CONTENT_DIV_JSON", editorProps: { $blockScrolling: true }, width: "100%", height: this.getEditorHeight(), fontSize: 14, value: this.state.jsonTestRaw, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } }),
                React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться", btnLoad: "Загрузить" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this), onLoadClick: this.OnLoadDataClick.bind(this) }))));
    };
    return BrandSmsTemplateTestJSONEditor;
}(React.Component));
exports.default = BrandSmsTemplateTestJSONEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/sms/BrandSmsTemplateTestJSONEditor.tsx
// module id = 1794
// module chunks = 0